export default __webpack_public_path__ + "static/media/payment-momo.9fe96cd7.svg";